import styled from 'styled-components'
import { spacing } from '~theme'
import { FieldStyled } from './Field'

interface FieldsetProps {
  size?: 'small' | 'medium' | 'large'
}

export const Fieldset = styled.fieldset<FieldsetProps>`
  & + & {
    margin-top: ${({ size }) => (size === 'small' ? spacing() : spacing(1.25))};
  }

  ${FieldStyled} + ${FieldStyled} {
    margin-top: ${({ size }) => (size === 'small' ? spacing(0.75) : spacing(1.25))};
  }
`
